'use strict';

/**
 * @description Initialize event handlers on landing page
 */

window.addEventListener('mainJsLoaded', function () {
    massimoVitaliHS18Init();
});

function massimoVitaliHS18Init() {
    var $productsCarousel = $('#js-productsCarousel'),
        $looksCarousel = $('#js-looksCarousel');

    // carousel init on image load
    $productsCarousel.find('img').first().one('load', function () {
        if (window.vbqUtils.breakpoint.is('fromDesktop')) {
            $productsCarousel.slick({
                slidesToShow: 4,
                dots: false,
                arrows: true,
                swipe: true,
                adaptiveHeight: true
            });
        }
        else {
            $productsCarousel.slick({
                slidesToShow: 1,
                dots: true,
                arrows: false,
                swipe: true,
                adaptiveHeight: true
            });
        }
    });

    // carousel re-init on media query change only!
    window.vbqUtils.breakpoint.set([
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('mobileAndTablet'),
            enter: function () {
                $productsCarousel.slick({
                    slidesToShow: 1,
                    dots: true,
                    arrows: false,
                    swipe: true,
                    adaptiveHeight: true
                });
            }
        },
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('fromDesktop'),
            enter: function () {
                $productsCarousel.slick({
                    slidesToShow: 4,
                    dots: false,
                    arrows: true,
                    swipe: true,
                    adaptiveHeight: true
                });
            }
        }
    ], true); // on media query change only

    var setLooksCarousel = function () {
        if ($looksCarousel.length) {
            if ($looksCarousel.hasClass('slick-initialized')) {
                $looksCarousel.slick('unslick');
            }

            var isMobile = window.vbqUtils.breakpoint.is('mobile'),
                isTablet = window.vbqUtils.breakpoint.is('tablet'),
                slidesToShow = isMobile ? 2 : (isTablet ? 3 : 4);

            $looksCarousel.slick({
                slidesToShow: slidesToShow,
                rows: isMobile ? 2 : 1,
                dots: isMobile || isTablet,
                arrows: !isMobile && !isTablet,
                swipe: true,
                mobileFirst: true,
                adaptiveHeight: true
            });
        }
    };

    window.vbqUtils.cache.$window.resize(window.vbqUtils._debounce(function () {
        setLooksCarousel();
    }, 200));

    setLooksCarousel();
}
